import React, { CSSProperties } from 'react';
import { useDraggable } from '@dnd-kit/core';

function Draggable(props: { children?: any; answer: TResponse; style: CSSProperties }) {
  const { answer } = props;
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: answer.id,
  });
  const style = transform ? {
    transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
    padding: 0,
    margin: 0,
    background: "none",
    border: "none",
  } : {
    padding: 0,
    margin: 0,
    background: "none",
    border: "none",
    touchAction: "none",
  };


  return (
    <button ref={setNodeRef} style={style} {...listeners} {...attributes}>
      {props.children}
    </button>
  );
}

export default Draggable;